module.exports = __webpack_public_path__ + "static/media/climatePondicherry.2503fdf5.webp";